'use client'

import { useTrackOnce } from '@/lib/analytics'

export default function ArchiveArticleAnalytics({ slug }: { readonly slug: string }) {
  useTrackOnce('mist_archive_article_viewed', {
    route: `/archive/${slug}`,
    archive_article_slug: slug,
  })
  return null
}
